// The session window's registration (docs/map.md): the window `session`, Home's New Session, and the panes it
// can show (panes/index.js). A session's own window is keyed by the session; another window on it ("Another
// window on this session", a pane opened in its own window) gets a key of its own.
import { registerWindow, sessionOf, nextSerial } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { paneStyles } from './panes.js'
import './panes/index.js'

registerWindow('session', {
  module: () => import('./session.js'),
  css: () => ['windows/session/session.css', ...paneStyles()],
  key: (a, macKey, app) => 'session-' + sessionOf(a) + (typeof a === 'object' && (a.mode || a.another) && app.windows.some((w) => w.id === 'session-' + sessionOf(a)) ? '-' + nextSerial() : ''),
  title: (a, app) => app.sessionTitle?.(sessionOf(a)) || 'Session',   // until its Mac lists it: then renamed (app.js retitle)
  perMac: false,   // titled by its session, not its Mac (app.js macTitled)
})
registerHomeItem({ id: 'newsession', label: 'New Session', symbol: 'plus.bubble', needs: 'paired', section: 'toolbar', order: 110, open: (app, key) => app.openWindow('newwindow', { mode: 'session' }, key) })
